import type { Locale } from '@st/i18n';

const LOCALE_TAG: Record<Locale, string> = { hr: 'hr-HR', en: 'en-GB' };

export function formatNumber(value: number, locale: Locale, digits = 0): string {
  return new Intl.NumberFormat(LOCALE_TAG[locale], {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);
}

/**
 * Zadana valuta kad je poslužitelj ne pošalje. `Intl.NumberFormat` uz
 * `style: 'currency'` BACA iznimku ako kod nedostaje ili nije tri slova, a
 * iznimka u formatiranju ruši cijeli ekran (React Router uhvati je tek u
 * `errorElement`). Jedno polje koje fali ne smije obrisati stranicu.
 */
const FALLBACK_CURRENCY = 'EUR';
const CURRENCY_CODE = /^[A-Za-z]{3}$/;

export function formatMoney(
  amountCents: number | null | undefined,
  currency: string | null | undefined,
  locale: Locale,
): string {
  const cents = Number.isFinite(amountCents) ? Number(amountCents) : 0;
  const code = currency && CURRENCY_CODE.test(currency) ? currency.toUpperCase() : FALLBACK_CURRENCY;
  return new Intl.NumberFormat(LOCALE_TAG[locale], {
    style: 'currency',
    currency: code,
    maximumFractionDigits: cents % 100 === 0 ? 0 : 2,
  }).format(cents / 100);
}

export function formatDate(iso: string, locale: Locale): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return new Intl.DateTimeFormat(LOCALE_TAG[locale], {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(d);
}

export function formatDay(iso: string, locale: Locale): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return new Intl.DateTimeFormat(LOCALE_TAG[locale], { weekday: 'short', day: 'numeric', month: 'short' }).format(d);
}

export function formatTime(iso: string, locale: Locale): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return new Intl.DateTimeFormat(LOCALE_TAG[locale], { hour: '2-digit', minute: '2-digit' }).format(d);
}

export function todayIso(now: Date = new Date()): string {
  return now.toISOString().slice(0, 10);
}

export function addDays(iso: string, days: number): string {
  const d = new Date(`${iso}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}
